<div class="range-slider-wrapper" #sliderWrapper>
  <div class="range-slider-track-wrapper">
    <div class="range-slider-track-background"></div>
    <div class="range-slider-track-fill" [ngStyle]="_getTrackFillStyles()"></div>
  </div>
  <div class="range-slider-thumb-container" [ngStyle]="_thumbContainerStyles('low')">
    <div class="range-slider-thumb range-slider-thumb-low"></div>
  </div>
  <div class="range-slider-thumb-container" [ngStyle]="_thumbContainerStyles('high')">
    <div class="range-slider-thumb range-slider-thumb-high"></div>
  </div>
</div>
